import type { CharacterId } from "../game/GameBus";
import type { LevelNumber } from "../game/levels";
import type { AccessoryId } from "../game/wardrobe";
import { CharacterPreview } from "./CharacterPreview";
import { SettingsIcon, SoundIcon } from "./Icons";

interface CharacterSelectProps {
  selected: CharacterId;
  muted: boolean;
  levelByCharacter: Record<CharacterId, LevelNumber>;
  accessoryByCharacter: Record<CharacterId, AccessoryId | null>;
  totalLevels: number;
  onSelect: (character: CharacterId) => void;
  onStart: () => void;
  onToggleMute: () => void;
  onOpenSettings: () => void;
}

export function CharacterSelect({
  selected,
  muted,
  levelByCharacter,
  accessoryByCharacter,
  totalLevels,
  onSelect,
  onStart,
  onToggleMute,
  onOpenSettings,
}: CharacterSelectProps) {
  const selectedLevel = levelByCharacter[selected];

  return (
    <main className="select-screen">
      <div className="select-backdrop dragon-backdrop" />
      <div className="select-backdrop unicorn-backdrop" />
      <button className="round-icon-button shell-button sound-button" onClick={onToggleMute} aria-label={muted ? "הפעלת צלילים" : "השתקת צלילים"}><SoundIcon muted={muted} /></button>
      <button className="round-icon-button shell-button settings-button" onClick={onOpenSettings} aria-label="הגדרות"><SettingsIcon /></button>

      <header className="game-title" aria-label="מסעות הקסם">
        <span>מסעות</span>
        <strong>הקסם</strong>
      </header>

      <section className="character-choices" aria-label="בחירת דמות">
        <button className={`character-choice dragon-choice ${selected === "dragon" ? "selected" : ""}`} onClick={() => onSelect("dragon")} aria-pressed={selected === "dragon"} aria-label={`דרקון, שלב ${levelByCharacter.dragon} מתוך ${totalLevels}`}>
          <CharacterPreview character="dragon" accessoryId={accessoryByCharacter.dragon} decorative />
          <span>דרקון</span>
          <small className="character-progress" aria-hidden="true">שלב {levelByCharacter.dragon} מתוך {totalLevels}</small>
        </button>
        <button className={`character-choice unicorn-choice ${selected === "unicorn" ? "selected" : ""}`} onClick={() => onSelect("unicorn")} aria-pressed={selected === "unicorn"} aria-label={`חד־קרן, שלב ${levelByCharacter.unicorn} מתוך ${totalLevels}`}>
          <CharacterPreview character="unicorn" accessoryId={accessoryByCharacter.unicorn} decorative />
          <span>חד־קרן</span>
          <small className="character-progress" aria-hidden="true">שלב {levelByCharacter.unicorn} מתוך {totalLevels}</small>
        </button>
      </section>

      <button className="primary-button start-button" onClick={onStart}>{selectedLevel > 1 ? `המשך משלב ${selectedLevel}` : "התחלה"}</button>
    </main>
  );
}
